// Dash-only routes that a shared page links to. They follow their feature into
// `@sparklayer-io/dashboard` once nothing in this package navigates to them.
export const PLATFORM_PATH = '/integrations/platform';
export const METAFIELDS_PATH = `${PLATFORM_PATH}/metafields`;
